import { invalidateQuery } from '../../queryCacheUtils';
import { URLKeys } from '../resources';

/**
 * Invalidate every cache that reflects which cars are enrolled in a schedule:
 * the schedule's own vehicle list, the cross-schedule car list, the schedule
 * detail and list (vehicle counts) and the department car lists (a swap can
 * attach a car to the department).
 */
export const invalidateAfterFleetScheduleVehicleMutation = async (): Promise<void> => {
  await Promise.all([
    invalidateQuery({ urlKey: URLKeys.getPaginatedFleetScheduleVehicles }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedFleetScheduleVehiclesAll }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedFleetScheduleVehicleBookings }),
    invalidateQuery({ urlKey: URLKeys.getFleetSchedule }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedFleetSchedules }),
    invalidateQuery({ urlKey: URLKeys.getDepartment }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedDepartments }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedFleetViewCars }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedUserGroupCars })
  ]);
};
